/** Scroll to an in-page anchor (e.g. #gallery). Retries while lazy content mounts. */
export function scrollToHashTarget(hash: string): () => void {
  const id = hash.replace(/^#/, '').trim()
  if (!id) return () => {}

  const attempt = () => {
    const el = document.getElementById(id)
    if (!el) return false
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    return true
  }

  if (attempt()) return () => {}

  const timers = [50, 150, 350, 700, 1200, 2000].map((ms) => window.setTimeout(() => attempt(), ms))
  return () => timers.forEach((t) => window.clearTimeout(t))
}
